import * as React from "react";
import { RichMarker, RichMarkerPosition } from "../googlemaps/richmarker";
import { MapComponentProps } from "../googlemaps/map";
import * as flightAwareMessages from '../../models/flightawaremessages';
//Simport { isFlightAwarePosition } from "../../models/flightaware";

import '../../map.css';

interface AircraftMarkerProps extends DOMEvents<HTMLImageElement>, MapComponentProps {
    aircraftImage?: string;
    tailNumber: string;
    aircraftType: string;
    aircraftTypeCode: string;
    departure?: string;
    arrival?: string;
    scheduledArrivalTimeUTC: string;
    scheduledArrivalTimeLocal: string;
    flightAwareEstimatedArrivalTimeUTC: string | null;
    flightAwareEstimatedArrivalTimeLocal: string | null;
    position: flightAwareMessages.Position;
    children?: never;
}

export const AircraftMarker: React.FC<AircraftMarkerProps> = ({
    map,
    aircraftImage,
    tailNumber,
    aircraftType,
    aircraftTypeCode,
    departure,
    arrival,
    scheduledArrivalTimeUTC,
    scheduledArrivalTimeLocal,
    flightAwareEstimatedArrivalTimeUTC,
    flightAwareEstimatedArrivalTimeLocal,
    position,
    ...imgEvents
}) => {




    function renderAircraft(_: {}, ref: React.Ref<HTMLImageElement>) {

        function getTime() {
            if (flightAwareEstimatedArrivalTimeUTC) {
                return <> {flightAwareEstimatedArrivalTimeLocal && <>{flightAwareEstimatedArrivalTimeLocal}L / </>}{flightAwareEstimatedArrivalTimeUTC}Z</>
            } else {
                return <>{scheduledArrivalTimeLocal && <>{scheduledArrivalTimeLocal}L / </>}{scheduledArrivalTimeUTC}Z</>
            }
        }

        function getDetails() {
            return (
                <span style={{ color: '#fff' }}>
                    {tailNumber} {aircraftTypeCode}<br />
                    {departure || <b>????</b>} > {arrival || <b>????</b>}<br />
                    {getTime()}
                </span>
            )
        }

        if (position.heading) {
            if (position.heading <= 180) {
                return (
                    <table>
                        <tbody>
                            <tr>
                                <td><img src={aircraftImage} ref={ref} style={{ transform: 'rotate(' + position.heading + 'deg)' }} {...imgEvents} alt="" /> </td>
                                <td className="map-tailnumber-right">
                                    {getDetails()}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                )
            }

            return (
                <table>
                    <tbody>
                        <tr>
                            <td className="map-tailnumber-left">
                                {getDetails()}
                            </td>
                            <td><img src={aircraftImage} ref={ref} style={{ transform: 'rotate(' + position.heading + 'deg)' }} {...imgEvents} alt="" /></td>
                        </tr>
                    </tbody>
                </table>
            )
        }

        return (
            <table>
                <tbody>
                    <tr>
                        <td><img src={aircraftImage} ref={ref} {...imgEvents} alt="" /></td>
                        <td className="map-tailnumber-left">{tailNumber}</td>
                    </tr>
                </tbody>
            </table>
        )
    }

    if (!position) return null;

    return <RichMarker map={map} position={position} anchor={RichMarkerPosition.MIDDLE} content={renderAircraft}/>
}

AircraftMarker.defaultProps = {
        aircraftImage: '/img/map/baseline-airplanemode_active-24px.svg',
    }

AircraftMarker.displayName = 'Map.AircraftMarker';
